import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { SearchResultsStore } from 'stores/search-results-store';

import { classNames } from 'uitk-react-utils';
import { UitkLink } from 'uitk-react-link';
import { UitkSpacing } from 'uitk-react-spacing';

import { PlaybackFilterPill } from './playback-filter-pill';

export interface PlaybackFilterProps extends Partial<RouteComponentProps> {
  centerPills?: boolean;
  wrapPills?: boolean;
  hideRemoveAllButtonsCTA?: boolean;
  searchResults?: SearchResultsStore;
  analytics?: any;
}

// @ts-ignore
@withRouter
@inject('searchResults', 'analytics')
@observer
export class PlaybackFilter extends React.Component<PlaybackFilterProps> {
  private removeAllFilters = () => {
    const { searchResults, history, location } = this.props;
    searchResults.clearFilters(history, location);
  };

  public render() {
    const { analytics, searchResults, wrapPills, centerPills, hideRemoveAllButtonsCTA } = this.props;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const isLoading = searchResults && searchResults.isLoading;
    const pills = (sortAndFilter && sortAndFilter.pills) || [];
    const defaults = sortAndFilter && sortAndFilter.defaults;
    const playbackPills = [];

    const classes = classNames(
      {
        'uitk-scroll-horizontal': !wrapPills,
        'uitk-flex-wrap': wrapPills,
        'uitk-flex-justify-content-center': centerPills,
        'all-l-padding-one': !wrapPills,
      },
      'uitk-flex playback-pill-grid'
    );

    pills.forEach(pill => {
      const pillNoSpacing = (
        <PlaybackFilterPill
          key={`playback-filter-${pill.name}-${pill.value}`}
          pill={pill}
          disabled={isLoading}
          defaults={defaults}
        />
      );
      const playbackFilterPill = wrapPills ? (
        <UitkSpacing margin={{ blockend: 'three', inlineend: 'three' }}>
          <div>{pillNoSpacing}</div>
        </UitkSpacing>
      ) : (
        pillNoSpacing
      );

      playbackPills.push(playbackFilterPill);
    });

    if (playbackPills.length > 0) {
      const a11yHeadingMessage =
        playbackPills.length === 1 ? 'hotels.searchResults.singleFilter.a11yLabel' : 'hotels.searchResults.multiFilters.a11yLabel';

      const renderRemoveAllCTA = !hideRemoveAllButtonsCTA && wrapPills && pills.length > 1;

      return (
        <section data-stid="playback-filter-section" className={classes}>
          <h3 className="is-visually-hidden">
            <LocalizedText message={a11yHeadingMessage} />
          </h3>
          {playbackPills}
          {renderRemoveAllCTA && (
            <UitkSpacing padding={{ block: 'two' }}>
              <div>
                <UitkLink
                  size="small"
                  inline={true}
                  onClick={this.removeAllFilters}
                  analytics={analytics && analytics.setupTracker('playback.removeAllFilters', 'Remove all filters applied', null)}
                >
                  <button disabled={isLoading}>
                    <LocalizedText message="hotels.searchResults.playbackFilter.removeAllFilters.linkText" />
                  </button>
                </UitkLink>
              </div>
            </UitkSpacing>
          )}
        </section>
      );
    }

    return null;
  }
}
